import React from "react";

import SvgI24Details from "assets/icons/I24Details";
import SvgI24Edit from "assets/icons/I24Edit";

import { Button, Typography } from "@material-ui/core";

import PublishStatus from "components/PublishStatus";
import TrimmedText from "components/TrimmedText";

import {
  getPublishButtonTextManualBadge,
  getPublishButtonIcon,
} from "utils/publish";

import {
  Container,
  ImageContainer,
  DetailsContainer,
  TextContainer,
  TitleWrapper,
  BottomControlsContainer,
  ControlWrapper,
  MenuContent,
  MenuContentWrapper,
  SubTitleWrapper,
} from "./styles";
import { formatDate } from "utils/date";

type Props = {
  title: string;
  successful: number;
  image?: string;
  publishStatus?: string;
  date?: string;
  onEdit?: () => void;
  onDetailsClick?: () => void;
  onPublish?: () => void;
};

const ManualBadgeCard = (props: Props) => {
  const {
    title,
    successful,
    image,
    publishStatus,
    date,
    onEdit,
    onDetailsClick,
    onPublish,
  } = props;

  return (
    <Container>
      <ImageContainer image={image} />
      <DetailsContainer>
        <TextContainer>
          <TitleWrapper onClick={onDetailsClick}>
            <TrimmedText lines={1} text={title}>
              <Typography variant="h3" color="textPrimary">
                {title} - {formatDate(date)}
              </Typography>
            </TrimmedText>
          </TitleWrapper>
          {successful > 0 && (
            <SubTitleWrapper>
              <Typography
                variant="subtitle1"
                color="primary"
                style={{ fontWeight: 500 }}
              >
                {`${successful} Successful users`}
              </Typography>
            </SubTitleWrapper>
          )}
        </TextContainer>
        <BottomControlsContainer marginTop={successful > 0 ? "10px" : "40px"}>
          <ControlWrapper>
            <Button
              startIcon={<SvgI24Details />}
              variant="text"
              color="secondary"
              onClick={onDetailsClick}
            >
              Details
            </Button>
          </ControlWrapper>
          <ControlWrapper>
            <Button
              startIcon={<SvgI24Edit />}
              variant="text"
              color="secondary"
              onClick={onEdit}
            >
              Edit
            </Button>
          </ControlWrapper>
          {successful > 0 && (
            <ControlWrapper>
              <Button
                startIcon={getPublishButtonIcon(publishStatus)}
                variant="text"
                color="secondary"
                onClick={onPublish}
              >
                {getPublishButtonTextManualBadge(publishStatus)}
              </Button>
            </ControlWrapper>
          )}
        </BottomControlsContainer>
      </DetailsContainer>
      {successful > 0 && (
        <MenuContent>
          <MenuContentWrapper>
            <PublishStatus status={publishStatus} />
          </MenuContentWrapper>
        </MenuContent>
      )}
    </Container>
  );
};

export default ManualBadgeCard;
